import {z} from 'zod'

import {CountryCodeEnum} from '@sdox/api'

import type {BlockMetaInputWithoutDocumentId} from '@sdox/api'
import type {FieldValues} from 'react-hook-form'

export type UpdateMetaSchema = z.infer<typeof updateMetaSchema>

export const updateMetaSchema = z.object({
  id: z.string(),
  panelId: z.string(),
  pullout: z.boolean(),
  countryCodes: z.array(z.nativeEnum(CountryCodeEnum)),
}).required()

export const getUpdateMetaFromFieldValues = (fieldValues: FieldValues): BlockMetaInputWithoutDocumentId => {
  const meta: BlockMetaInputWithoutDocumentId = {
    id: fieldValues.meta.id,
    panelId: fieldValues.meta.panelId,
    pullout: fieldValues.meta.pullout,
    countryCodes: fieldValues.meta.countryCodes,
  }

  return updateMetaSchema.parse(meta)
}
